import { render, staticRenderFns } from "./TagsEdit.vue?vue&type=template&id=630c094a&scoped=true&"
import script from "./TagsEdit.vue?vue&type=script&lang=js&"
export * from "./TagsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagsEdit.vue?vue&type=style&index=0&id=630c094a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c094a",
  null
  
)

export default component.exports